import React, { useEffect, useRef, useState } from "react";
import { billingService } from "../../Services";
import AppButton from "../../Components/AppButton";
import AppTextArea from "../../Components/Base/Form/AppTextArea";
import AppTextAmount from "../../Components/Base/Form/AppTextAmount";
import { Modal } from "../../Components";

export default function ModalBilling({ close, open,setIsBalanceAdded, addToast }) {
  const paypal = useRef(null);
  const stripe = useRef(null);
  const [account, setAccount] = useState("stripe"); // default Stripe
  const [description, setDescription] = useState("");
  const [amount, setAmount] = useState("");
  const [error, setError] = useState(false);
  const [toastList, setToastList] = useState([]);
  const [disableButton, setDisableButton] = useState(false);

  const addAmount = useRef(null);

  useEffect(() => {
    if (account === "paypal" && stripe.current) stripe.current.checked = false;
    if (account === "stripe" && paypal.current) paypal.current.checked = false;
  }, [account]);

  const setInput = (key) => (event) => {
    if (key === "description") {
      setDescription(event.target.value);
    } else {
      setAmount(event.target.value);
    }
  };

  useEffect(() => {
    const keyDownHandler = (event) => {
      if (event.key === "Enter") {
        addAmount.current.click();
      }
    };
    document.addEventListener("keydown", keyDownHandler);
    return () => {
      document.removeEventListener("keydown", keyDownHandler);
    };
  }, [amount, description, account]);

  const saveChanges = () => {
    if (amount !== "" && description !== "" && account && amount >= 500) {
      saveBalance();
    } else {
      setError(true);
    }
  };

  const saveBalance = async () => {
    setDisableButton(true);
    const payload = { amount, description, account };
    try {
      const res = await billingService.addBalance(payload);
      window.location.replace(res.url);
      setIsBalanceAdded(false);
    } catch (error) {
      addToast({
        error: true,
        msg: error,
        id: `${Date.now()}-${toastList.length}`,
      });
      setDisableButton(false);
    }
  };

  return (
    <Modal
       open={open}
      close={close}
      aria-labelledby="application-details-modal"
      aria-describedby="application-details-description"
      className="!flex !items-center !justify-center p-4 "
      modelInnerClass="!max-w-[500px] !w-full"
    >
    {/* <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"> */}
      <div className="bg-white rounded-xl shadow-xl w-full max-w-md overflow-hidden">
        {/* Modal Header */}
        <div className="p-6 bg-gradient-to-r from-blue-50 to-indigo-50 border-b border-gray-200">
          <div className="flex justify-between items-start">
            <div>
              <h3 className="text-2xl font-bold text-gray-800">Add Funds</h3>
              <p className="text-gray-600 mt-1">
                Select the account you would like to add funds from.
              </p>
            </div>
            <button
              onClick={close}
              className="text-gray-400 hover:text-gray-600 transition-colors"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>
        </div>

        {/* Payment Methods */}
        <div className="p-6">
          <h4 className="text-sm font-medium text-gray-700 mb-3">
            PAYMENT METHOD
          </h4>
          <div className="grid grid-cols-2 gap-4">
            {/* Stripe */}
            <div
              className={`border-2 rounded-xl cursor-pointer transition-all ${
                account === "stripe"
                  ? "border-blue-500 bg-indigo-50"
                  : "border-gray-200 hover:border-gray-300"
              }`}
              onClick={() => setAccount("stripe")}
            >
              <div className="text-center">
                <input
                  ref={stripe}
                  type="radio"
                  className="sr-only"
                  checked={account === "stripe"}
                  onChange={() => setAccount("stripe")}
                />
                <img
                  src={process.env.PUBLIC_URL + "/images/stripe3.png"}
                  alt="paypal"
                  className="h-12 w-24 ml-10 "
                />
              </div>
            </div>
            {/* PayPal */}
            <div
              className={`border-2 rounded-xl cursor-pointer transition-all ${
                account === "paypal"
                  ? "border-blue-500 bg-blue-50"
                  : "border-gray-200 hover:border-gray-300"
              }`}
              onClick={() => setAccount("paypal")}
            >
              <div className="justify-center">
                <input
                  ref={paypal}
                  type="radio"
                  className="sr-only"
                  checked={account === "paypal"}
                  onChange={() => setAccount("paypal")}
                />
                <img
                  src={process.env.PUBLIC_URL + "/images/paypal.png"}
                  alt="paypal"
                  className="ml-5"
                />
              </div>
            </div>
          </div>

          {/* Amount */}
          <div className="mt-6">
            <h4 className="text-sm font-medium text-gray-700 mb-2">
              AMOUNT (MIN 500)
            </h4>
            <div
              className={`flex items-center border border-gray-300 rounded-lg overflow-hidden focus-within:ring-2  ${
                error
                  ? "focus-within:ring-red-500 "
                  : "focus-within:ring-blue-500 "
              }`}
            >
              <div className="px-4 py-3 bg-gray-50 border-r border-gray-300">
                <span className="font-medium text-gray-600">USD</span>
              </div>
              <AppTextAmount
                placeholder="Enter amount"
                error=""
                value={amount}
                type="number"
                autoFocus
                className={`flex-1 !py-3 !px-4`}
                onChange={setInput("amount")}
              />
            </div>
            {error && amount < 500 && (
              <p className="mt-1 text-sm text-red-600">
                Minimum amount of 500 needed
              </p>
            )}
          </div>

          {/* Description */}
          <div className="mt-6">
            <h4 className="text-sm font-medium text-gray-700 mb-2">
              DESCRIPTION
            </h4>
            <AppTextArea
              row="4"
              error={error}
              value={description}
              errorText="Please enter Description"
              onChange={setInput("description")}
              placeholder="Enter description for what purpose you are adding this amount."
              className="w-full px-4 py-3 "
            />
          </div>

          {/* Button */}
          <div className="mt-6">
            <AppButton          
              // fromColor="blue-500"
              // toColor="blue-700"
              // hoverFrom="blue-400"
              // hoverTo="blue-600"
              ref={addAmount}
              disabled={disableButton}
              className="w-full py-3 !bg-gradient-to-r !from-blue-500 !to-blue-700 hover:!from-blue-700 hover:!to-blue-500 "
              onClick={() => {
                saveChanges();
                setError(true);
              }}
            >
              {disableButton ? (
                <div className="flex items-center justify-center">
                  <svg
                    className="animate-spin -ml-1 mr-2 h-4 w-4 text-white"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      className="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      strokeWidth="4"
                    ></circle>
                    <path
                      className="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8V0C5.373 
0 0 5.373 0 12h4z"
                    ></path>
                  </svg>
                  Processing...
                </div>
              ) : (
                "Add Balance"
              )}
            </AppButton>
          </div>
        </div>
      </div>
    {/* </div> */}
    </Modal>
  );
}
